    // Burger Menu Functionality
    const burgerToggle = document.getElementById('burger-menu-toggle');
    const burgerMenu = document.getElementById('burger-menu');
    const burgerMenuContent = burgerMenu.querySelector('.burger-menu-content');
    const submenuToggles = burgerMenu.querySelectorAll('.burger-menu-toggle');
    const submenus = burgerMenu.querySelectorAll('.burger-menu-submenu');

    // Toggle burger menu
    burgerToggle.addEventListener('click', function () {
        const isOpen = burgerMenu.classList.contains('burger-menu-open');

        if (isOpen) {
            closeBurgerMenu();
        } else {
            openBurgerMenu();
        }
    });

    // Close menu when clicking overlay
    burgerMenu.addEventListener('click', function (e) {
        if (e.target === burgerMenu || e.target.classList.contains('burger-menu-overlay') || e.target.classList.contains('burger-menu-wrapper')) {
            closeBurgerMenu();
        }
    });

    // Handle submenu toggles
    submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
    
            const submenuWrapper = toggle.closest('.burger-menu-item').querySelector('.burger-menu-submenu');
            const isExpanded = toggle.classList.contains('burger-menu-toggle-expanded');
    
            if (isExpanded) {
                closeSubmenu(toggle, submenuWrapper);
            } else {
                openSubmenu(toggle, submenuWrapper);
            }
        });
    });

    // Close menu on escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burgerMenu.classList.contains('burger-menu-open')) {
            closeBurgerMenu();
        }
    });

    function openBurgerMenu() {
        burgerMenu.classList.add('burger-menu-open');
        burgerToggle.classList.add('header-menu-btn-active');
        burgerToggle.setAttribute('aria-label', 'Luk menu');
        document.body.style.overflow = 'hidden';
    }

    function closeBurgerMenu() {
        burgerMenu.classList.remove('burger-menu-open');
        burgerToggle.classList.remove('header-menu-btn-active');
        burgerToggle.setAttribute('aria-label', 'Menu');
        document.body.style.overflow = '';

        // Close all submenus
        submenuToggles.forEach((toggle, index) => {
            const submenu = submenus[index];
            closeSubmenu(toggle, submenu);
        });
    }

    function openSubmenu(toggle, submenu) {
        toggle.classList.add('burger-menu-toggle-expanded');
        submenu.classList.add('burger-menu-submenu-expanded');
        toggle.setAttribute('aria-expanded', 'true');
    }

    function closeSubmenu(toggle, submenu) {
        toggle.classList.remove('burger-menu-toggle-expanded');
        submenu.classList.remove('burger-menu-submenu-expanded');
        toggle.setAttribute('aria-expanded', 'false');
    }